import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs';

const list = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/channel-price/${merchantId}/channel-price/list`,
		payload
	);
};

const fileExport = (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/channel-price/${merchantId}/channel-price/list/export`,
		payload,
		{ responseType: 'blob' },
		{
			headers: {
				'Content-Type': 'application/octet-stream',
			},
		}
	);
};

const categoryList = async (merchantId, payload) => {
	return Client.get(
		`${baseUrl}/channel-price/${merchantId}/channel-price/categories`,
		payload
	);
};

export default {
	list,
	fileExport,
	categoryList,
};
